import postFetcher from './postFetcher';

const postFetcherQuiet = async <TBody = Object>({ url, body }: { url: string; body: TBody }) =>
  postFetcher({ url, body, throwOnError: false });

export default postFetcherQuiet;
